/* global __HOT__ */
// @jsx h
import domready from 'domready'
import { h, render } from 'preact'
import { nodelistToArray } from '../lib/nodelistToArray'
import { uuid } from '../lib/uuid'
import { createErrorReporter } from '../lib/errorReporting'
import { App } from './components/withComparison/App'
import { withComparisonRoot as rootElementClassName } from './components/withComparison/App.css'
import { createGoogleAnalyticsTracker } from '@nrk/dh-analytics-utils'
import { getContextId } from '../lib/getContextId'

window[rootElementClassName] = window[rootElementClassName] || {}

function init () {
  findElements().forEach(el => {
    el.id = uuid()
    window[rootElementClassName][el.id] = true

    // Extract preloaded state sent from server
    const preloadedState = JSON.parse(el.getAttribute('data-preloaded-state'))
    const errorEventTrackingEnabled = JSON.parse(el.getAttribute('data-error-event-tracking-enabled'))

    // Register error reporter
    const simpleErrorReport = createErrorReporter(errorEventTrackingEnabled)
    simpleErrorReport.listenAndCatch()

    // Extract metadata required to create google analytics tracker
    const gaPropertyId = el.getAttribute('data-ga-property-id')
    const metadata = JSON.parse(el.getAttribute('data-metadata'))
    const { title, selfId, published } = metadata

    // create google analytics tracker
    const googleAnalyticsTracker = createGoogleAnalyticsTracker({
      name: 'dh',
      gaPropertyId,
      self: {
        id: selfId,
        title,
        publishedDate: published ? new Date(published) : null
      },
      context: {
        id: getContextId(document.location.href)
      }
    })

    // ... and render with the exact same props
    render(<App {...preloadedState} />, el, el.firstChild)

    // track load event
    googleAnalyticsTracker.sendEvent({
      category: `dh-modul–partibarometer`,
      label: 'sammenlikning',
      action: 'load',
      value: new Date().getTime()
    })

    // Enable webpack hot-reloading
    if (__HOT__) {
      // Reload and re-render React application
      module.hot.accept('./withComparison-client', () => {
        render(require('./components/withComparison/App').default, el)
      })
    }
  })
}

function findElements () {
  return nodelistToArray(document.getElementsByClassName(rootElementClassName))
    .filter(el => !isInitialized(el))
}

function isInitialized (el) {
  return el.id && window[rootElementClassName][el.id]
}

domready(init)



// WEBPACK FOOTER //
// ./src/v1/withComparison-client.js